export const FEATURE_SETTINGS_URL = `/api/feature_settings`;
export const GET_FEATURE_SETTINGS = `${FEATURE_SETTINGS_URL}/get_settings`;
export const SET_FEATURE_SETTINGS = `${FEATURE_SETTINGS_URL}/set_settings`;